import { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { PacksContext } from '@/components/app/layout/PacksProvider';
import { useProgramInfo } from '@/hooks/app/useProgramInfo';
import { useProgramState, useThemeState } from '@/hooks/store';
import { setTheme } from '@/store/theme/actions';

export function useInitializeProgram(): void {
	const program = useProgramState();
	const theme = useThemeState();
	const dispatch = useDispatch();
	const { setPageTitle } = useContext(PacksContext);
	const { backgroundImage } = useProgramInfo();

	const [hasInitialized, setHasInitialized] = useState(false);

	useEffect(() => {
		setPageTitle(null);
		if (!hasInitialized && program) {
			dispatch(
				setTheme({
					...theme,
					webAppBackgroundImage: backgroundImage,
				}),
			);

			setHasInitialized(true);
		}
	}, [backgroundImage, dispatch, hasInitialized, program, setPageTitle, theme]);
}
